module.exports = __webpack_public_path__ + "img/footerBtnTeleg.0e6b9016.svg";